import { Component } from '@angular/core';
import { BaseDirectiveObject } from '../../../app/components/common/base-directive-object';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { Certificate } from '../signature.objects';
import { DATEPIPE_DATE_FORMAT } from '../../language.service';
import { TranslateService } from '@ngx-translate/core';
import { WaitLoadingService } from '../../../app/components/common/waitLoading/wait-loading.service';

@Component({
  templateUrl: 'certificate-selection.component.html',
  selector: 'certificate-selection',
  providers: [DialogService]
})
export class CertificateSelection extends BaseDirectiveObject {

  public certificates: Certificate[];
  public selected: Certificate;
  public DATEPIPE_DATE_FORMAT = DATEPIPE_DATE_FORMAT;
  public headers: string[];

  constructor(dialogConfig: DynamicDialogConfig, private dialogRef: DynamicDialogRef, private translateService: TranslateService,
    private waitService: WaitLoadingService) {
    super();
    this.certificates = dialogConfig?.data?.certificates;
    this.headers = [
      this.translateService.instant('General.name'),
      this.translateService.instant('Signature.Provider.Certificate.Issuer'),
      this.translateService.instant('Signature.Provider.Certificate.ValidFrom'),
      this.translateService.instant('Signature.Provider.Certificate.ValidTo'),
    ];
    this.waitService.cancelWaiting();
  }

  public close(): void {
    this.dialogRef.close(this.selected);
  }

}
